<template>
  <div id="my" :style="{ height: TableHeight + 'px' }">
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      style="margin-bottom: 30px"
    >
      <el-tab-pane label="个人信息" name="first">
        <el-card class="box-card">
          <div slot="header" class="clearfix" style="margin-top: 10px">
            <span>个人信息</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">修改</el-button> -->
          </div>
          <el-table :data="PIMS" border style="width: 100%">
            <el-table-column prop="name" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="department" label="部门"> </el-table-column>
            <el-table-column prop="account" label="账号"> </el-table-column>
            <el-table-column prop="tel" label="电话" width="180">
            </el-table-column>
            <el-table-column prop="login_times" label="登录次数" width="180">
            </el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="修改密码" name="third">
        <div class="wrap">
          <!-- <div class="step">
            <el-steps :active="active" finish-status="success" space="300px" align-center>
            <el-step title="验证手机号"></el-step>
            <el-step title="设置新密码"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>
          </div> -->
          <el-form
            class="loginForm"
            :model="loginForm"
            :rules="loginFormRules"
            ref="loginFormRef"
            label-width="100px"
          >
            <el-form-item label="" prop="phone">
              <el-input
                v-model="loginForm.phone"
                style="width: 320px"
                placeholder="请输入手机号"
                prefix-icon="el-icon-mobile-phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="verificationCode">
              <div style="position: relative">
                <el-input
                  v-model="loginForm.verificationCode"
                  style="width: 320px"
                  placeholder="请输入验证码"
                  autocomplete="off"
                >
                </el-input>
                <div class="codeBox">
                  <el-button
                    v-if="loginForm.showloginCode"
                    type="primary"
                    @click="getloginPhoneCode"
                    class="code"
                    autocomplete="off"
                    >获取验证码</el-button
                  >
                  <div v-else style="color: #999">
                    {{ loginForm.count }}秒后发送
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="" prop="password">
              <el-input
                v-model="loginForm.password"
                style="width: 320px"
                placeholder="请输入密码"
                type="password"
                clearable
                show-password
                autocomplete="new-password"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="login" class="btns"
                >提 交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item label="旧密码" prop="pass">
            <el-input
              type="password"
              v-model="hispass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >确定</el-button
            >
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form> -->
      </el-tab-pane>
      <!-- <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import { userdata, changebackstagepassword } from "../../static/API/API.js";
export default {
  name: "my",
  data() {
    // 验证手机号是否合法
    var checkMobile = (rules, value, callback) => {
      const regMobile =
        /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (regMobile.test(value) == true) {
        return callback();
      } else {
        callback(new Error("请输入合法的手机号"));
      }
    };
    return {
      hispass: "",
      ruleForm: {
        pass: "",
        checkPass: "",
      },
      activeName: "first",
      PIMS: [],
      TableHeight: 300,
      active: 0,
      loginForm: {
        phone: "",
        password: "",
        verificationCode: "", //表单中展示的验证码
        timer: null,
        showloginCode: true, //判断展示‘获取验证码’或‘倒计时’
        count: "", //倒计时时间
      },
      loginFormRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkMobile, trigger: "blur" },
        ],
        verificationCode: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    getHeight() {
      //动态计算表格高度
      this.$nextTick(() => {
        let windowHeight =
          document.documentElement.clientHeight || document.bodyclientHeight;
        this.TableHeight = windowHeight - 138; //数值"140"根据需要调整
      });
    },
    // 切换显示
    handleClick(tab, event) {
      // console.log(tab, event);
      if (tab.label == "个人信息") {
        this.PIM();
      }
    },
    // 个人信息
    PIM() {
      let params = new URLSearchParams();
      params.append("ope_type", "个人信息");
      params.append("user_id", sessionStorage.getItem("user_id"));
      this.$axios.post(userdata, params).then((res) => {
        this.PIMS = res.data;
      });
    },
    // 获取手机验证码
    getloginPhoneCode() {
      // 如果未输入手机号，结束执行
      if (this.loginForm.phone == "") {
        this.$message.error("请输入手机号");
        return;
      }
      let params = new URLSearchParams();
      params.append("tel", this.loginForm.phone);
      // 调用接口，向手机号发送验证码
      this.$axios.get(changebackstagepassword, { params }).then((res) => {
        if (res.status != 200) {
          return this.$message.error("验证码发送失败！");
        } else {
          // 当验证码发送成功，开始60秒倒计时
          const TIME_COUNT = 60;
          if (!this.loginForm.timer) {
            this.loginForm.showloginCode = false;
            this.loginForm.count = TIME_COUNT;
            this.loginForm.timer = setInterval(() => {
              if (
                this.loginForm.count > 0 &&
                this.loginForm.count <= TIME_COUNT
              ) {
                this.loginForm.count -= 1;
              } else {
                this.loginForm.showloginCode = true;
                clearInterval(this.loginForm.timer);
                this.loginForm.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    // 开始登录
    login() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          let params = new URLSearchParams();
          params.append("tel", this.loginForm.phone);
          params.append("verif", this.loginForm.verificationCode);
          params.append("password", this.loginForm.password);
          this.$axios.post(changebackstagepassword, params).then((res) => {
            if(res.data == '修改密码成功！'){
              this.$message.success("密码修改成功,请重新登录！");
              setTimeout(() => {
              this.$router.push("/");
              sessionStorage.removeItem("newTabName");
              sessionStorage.removeItem("editableTabs");
            }, 1000);
            }else{
              this.$message.error(res.data);
            }

          });
        } else {
          this.$message.error("请将信息填写完整！");
        }
      });
    },
  },
  mounted() {
    this.PIM();
    if (!!this.$route.query.name) {
      this.activeName = this.$route.query.name;
    }
    this.getHeight();
  },
  created() {
    window.addEventListener("resize", this.getHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
};
</script>

<style scoped>
#my {
  /* position: absolute; */
  /* display: flex; */
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

form {
  width: 45%;
  margin: auto;
  margin-top: 20px;
}
.loginForm {
  width: 500px;
}
.btns {
  width: 320px;
  margin-top: 5px;
}
.wrap {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.step {
  width: 600px;
  margin: auto;
  margin-bottom: 30px;
}
/deep/ .el-step__icon-inner {
  margin: 0 !important;
}
.codeBox {
  position: absolute;
  right: 90px;
  top: 0px;
}
.code {
  width: 100px;
  border: none;
  background: none;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/views/my.vue